
import React from 'react';
import { Radio, Button, RadioChangeEvent } from 'antd';
import styles from './BaseComponent.module.scss';
import { Company } from 'type/company';
import { getStaffId } from 'data/storage';
interface IProps {
  companyList: Company[]
  onSubmit: (val: string) => void
}
// 容器组件
const BaseComponent: React.FC<IProps> = ({ companyList, onSubmit }) => {
  const [value, setValue] = React.useState(getStaffId());
  const [disabled, setDisabled] = React.useState(!value);

  const onChange = (e: RadioChangeEvent) => {
    if (disabled && !value) {
      setDisabled(false);
    }
    setValue(e.target.value);
  };

  const onClick = () => {
    onSubmit && onSubmit(value || '');
  };
  const radioStyle = {
    display: 'block',
    height: '40px',
    lineHeight: '40px',
    fontSize: '16px'
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.title}>MAXHUB 会议预约系统</div>
        <div className={styles.content}>
          <div className={styles.contentTitle}>请选择企业身份</div>
          <div className={styles.selectZone}>
            <Radio.Group onChange={onChange} value={value}>
              {
                companyList.map(({ companyName, staffId }) => {
                  return (
                  <Radio style={radioStyle} value={staffId} key={staffId}>
                    {companyName}
                  </Radio>
                  );
                })
              }
            </Radio.Group>
          </div>
          <div className={styles.buttonWrapper}>
            <Button type="primary" disabled={disabled} onClick={onClick}>立即进入</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseComponent;
